module.exports = __webpack_public_path__ + "images/join-approval-empty-7a9d17970d320c51162bdf2c7299a6ee.jpg";